/**
 * Super Admin Customer CRM page wrapper — scoped to URL :brand_id.
 *
 * Renders a back link to the brand drilldown, then delegates to the
 * shared <CustomerCrmPage role="admin" />. The page enforces brand
 * context by always passing `brand_id` to every backend call (the
 * server returns 400 otherwise).
 */
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import CustomerCrmPage from '@/pages/CustomerCrmPage';
import Button from '@/components/ui_primitives/Button';

export default function AdminBrandCustomerCrmPage() {
  const { brand_id: brandId } = useParams();

  // Defensive: missing brandId route param → bounce to /admin/brands.
  useEffect(() => {
    if (!brandId) toast.error('Missing brand context — pick a brand first.');
  }, [brandId]);
  if (!brandId) return <Navigate to="/admin/brands" replace />;

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Link to={`/admin/brands/${brandId}`}>
          <Button
            variant="ghost" size="sm" leftIcon={<ArrowLeft size={12} />}
            testID="admin-crm-back-to-brand"
          >
            Back to brand
          </Button>
        </Link>
      </div>
      <CustomerCrmPage brandId={brandId} role="admin" />
    </div>
  );
}
